/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { ApiEntity } from 'app/api/models/api-entity.model';
import { SystemRole } from 'app/api/models/system-role.model';

export class User extends ApiEntity {
  summaryContentVisible: boolean = false;

  constructor(
    id: number,
    public username: string,
    public firstName: string,
    public surname: string,
    public email: string,
    public mobileNumber: string,
    public isActive: boolean,
    public roles: SystemRole[],
  ) {
    super(id);
  }

  toggleSummaryContent() {
    this.summaryContentVisible = !this.summaryContentVisible;
  }

  get fullname(): string {
    return this.firstName + ' ' + this.surname;
  }
}
